import { logError } from '@com-delta-idp/mnx-utils';
import { AEMRelatedLinks } from '../../../models';
import { getEmptyContent, isValidData } from '../../../utils';
import { RelatedLinks } from '../models/related-links.interfaces';

export const getRelatedLinks = (
  links: AEMRelatedLinks | undefined,
  featureFlag: boolean | undefined
): RelatedLinks => {
  try {
    return isValidData<
      AEMRelatedLinks,
      [AEMRelatedLinks | undefined, boolean | undefined]
    >('relatedLinkList', links, featureFlag)
      ? adaptRelatedLinks(links as AEMRelatedLinks, featureFlag as boolean)
      : getEmptyContent<RelatedLinks>();
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'SHARED', 'RELATED_LINKS');
    // TODO(Sabarish, Sai): To handle error message for Summary component
    return getEmptyContent<RelatedLinks>('', [], true, true);
  }
};

const adaptRelatedLinks = (
  links: AEMRelatedLinks,
  featureFlag: boolean
): RelatedLinks => {
  return featureFlag
    ? {
        links: links.relatedLinkList,
        disabled: !featureFlag,
        loaded: true
      }
    : getEmptyContent<RelatedLinks>('', [], true, true);
};
